export const FEDERAL_TAX_ID_MASK = '99-9999999';
